<template>
  <div class="dashboard-header">
    <div class="right">

      <span class="side-bar-toggler" @click="toggleSidebar(true)">
        <i class="mdi mdi-menu icon"></i>
      </span>
      <router-link :to="{ name:'Home' }">
        <i class="mdi mdi-home-outline icon"></i>
      </router-link>

    </div>
    <ul class="left">
      <li>
        <div v-if="userData.fullname" class="ar-drop-down-wrapper" tabindex="1">
          <div class="ar-drop-down-activator">
            <span>
              {{userData.fullname}}
            </span>
            <i class="mdi mdi-chevron-down arrow"></i>
          </div>
          <div class="ar-drop-down-body" style="min-width:170px;">
            <div class="py-1"><router-link :to="{name:'Profile'}"><i class="mdi mdi-person"></i> پروفایل</router-link></div>
            <div class="py-1"><router-link :to="{name:'Tickets'}"><i class="mdi mdi-support_agent"></i> تیکت ها</router-link></div>
          </div>
        </div>
        <template v-else>
          <router-link :to="{name:'Authentication'}">
            احراز هویت
          </router-link>
        </template>
      </li>
      <li class="mr-2">
        <router-link :to="{name:'Notifications'}">
          <i class="mdi mdi-bell-outline icon"></i>
          <span v-if="state_notifications_count" class="bdg">{{state_notifications_count}}</span>
        </router-link>
      </li>
    </ul>

  </div>
</template>
<script>
import LogoutBtn from '../../../components/LogoutBtn'
import ChatBtn from '../../../components/ChatBtn'
export default {
  name: 'Header',
  components:{
    LogoutBtn,
    ChatBtn
  },
  data : () => ({
  }),
  methods:{
  },
  mounted() {
  }
}
</script>
<style>
.disable{
  opacity: .4;
}
</style>